import React, { useEffect } from 'react';
import ExpiredOrderModal from '../../../../components/Purchase/ExpiredOrderModal';
import { useHistory } from 'react-router-dom';
import { useCheckoutMvp } from './hooks/useCheckoutMvp';
import { useDispatch } from 'react-redux';
import { cleanOrderSimulate } from '../../../../store/ducks/order-simulate-checkout-mvp/actions';
import { ERoutes } from '../../../../routes';
import { EPurchaseRoutes } from '../../purchase.routes';
import { useCartService } from '../../../../services/MVP/useCartService';
import { GetFlag } from '../../../../utils/featureFlag';
import { useLoadingModal } from '../../../../context/useModaContext';

const ExpiredOrder = () => {
  const history = useHistory();
  const { deleteCartId } = useCheckoutMvp();
  const { handleUpdateQuantity, deactivateCart } = useCartService();
  const dispatch = useDispatch();

  const newCartEndpoint = GetFlag('new_cart_endpoints');

  const { setLoadingModalOpen } = useLoadingModal();

  useEffect(() => {
    deleteCartId();
  }, []);

  const toCleanOrderSimulate = async () => {
    handleUpdateQuantity(0);
    if (newCartEndpoint) {
      setLoadingModalOpen(true);
      await deactivateCart();
      setLoadingModalOpen(false);
    }
    dispatch(cleanOrderSimulate());
  };

  const onBackOnClick = () => {
    history.push(ERoutes.DASHBOARD);
    toCleanOrderSimulate();
  };

  const onContinueOnClick = () => {
    history.push(
      `${ERoutes.PURCHASE}/${EPurchaseRoutes.COMMERCE}/${EPurchaseRoutes.STEEL_TYPE_CHOOSE}`
    );
    toCleanOrderSimulate();
  };

  return (
    <ExpiredOrderModal
      onBackClick={onBackOnClick}
      onStartClick={onContinueOnClick}
    />
  );
};

export default ExpiredOrder;
